import i18n from "lib/i18n";
import $ from "jquery";
import { defer, template } from "lodash";
import { View } from "backbone";
import CommentFormattingHelpView from "views/comment_formatting_help_view";
import CommentPreviewView from "views/comment_preview_view";
import UserNotificationSettingsView from "views/user_notification_settings_view";
import Minpubsub from "minpubsub";
import Flash from "lib/flash";
import { track } from "../lib/analytics";
/* eslint-disable
    consistent-return,
    constructor-super,
    func-names,
    max-len,
    no-alert,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentFormView;

export default CommentFormView = (function () {
  CommentFormView = class CommentFormView extends View {
    static initClass() {
      this.prototype.tagName = "li";

      this.prototype.events = {
        "focus textarea": "_onTextareaFocus",
        "blur textarea": "_onTextareaBlur",
        "keyup textarea": "_handleKeyUp",
        "input textarea": "_handleKeyUp",
        "paste textarea": "_handleKeyUp",
        "click .submit": "_handleSubmit",
        "click .toggle-comment-help": "_handleClickToggleCommentHelp",
        "click .toggle-comment-options": "_handleClickToggleCommentOptions",
        "click #comment-form-reply > .tabbed .tab": "_onTabClick",
      };

      // TODO: split user attribution into separate view
      this.prototype.template = template(`\
<div id="comment-form-reply">
  <div class="comment-errors"></div>

  <nav class="tabbed">
    <a href="#write" class="active tab"><%= i18n.t('comment.button.write') %></a>
    <a href="#preview" class="tab"><%= i18n.t('comment.button.preview') %></a>
  </nav>

  <div class="comment-form-reply-options">
    <a href="#" class="toggle-comment-options" title="<%= i18n.t('comment.label.notification_settings') %>">
      <i class="icon-cog"></i>
    </a>

    <a href="#" class="toggle-comment-help" title="<%= i18n.t('comment.label.formatting_help') %>">
      <i class="icon-help"></i>
    </a>
  </div>

  <div class="comment-form-reply-write">
    <form id="new_comment" class="new_comment">
      <label for="comment-form-reply-body"><%= i18n.t('comment.label.body') %></label>
      <textarea id="comment-form-reply-body" class="comment-body"></textarea>

      <span class="community-standards-link">
        <a href="/community_standards" target="_blank">
          <%= i18n.t('comment.label.review_community_standards') %>
        </a>
      </span>

      <a href="#" class="submit button primary"><%= i18n.t('comment.button.post_comment') %></a>
    </form>
  </div>

  <div class="comment-form-reply-preview"></div>
</div>\
`, { imports: { i18n } });
    }

    initialize(options) {
      super.initialize(options);
      this.remove = this.remove.bind(this);
      this._handleSubmissionSuccess = this._handleSubmissionSuccess.bind(this);
      this._handleSubmissionError = this._handleSubmissionError.bind(this);
      this._handleSubmissionComplete = this._handleSubmissionComplete.bind(this);
      this._onTabClick = this._onTabClick.bind(this);
      this._loadPreview = this._loadPreview.bind(this);
      this._onTextareaFocus = this._onTextareaFocus.bind(this);
      this._onTextareaBlur = this._onTextareaBlur.bind(this);
      this.user_full_name = TC.currentUser.get("full_name");
      this.render();
      this.commentBodyEl = this.$el.find("textarea.comment-body");
      this.submitButtonEl = this.$el.find(".button.primary");
      this.errorEl = this.$el.find(".comment-errors");
      this.contentSubscription = options.contentSubscription;

      Minpubsub.subscribe("comment:new", this.remove);

      this.userNoticationSettingsView = new UserNotificationSettingsView({ contentSubscription: this.contentSubscription });
      this.commentFormattingHelpView = new CommentFormattingHelpView();

      this.$el.find(".toggle-comment-help").after(this.commentFormattingHelpView.el);
      this.$el.find(".toggle-comment-options").after(this.userNoticationSettingsView.el);

      return defer(() => this.commentBodyEl.focus());
    }

    render() {
      return $(this.el).html(this.template({ user_full_name: this.user_full_name }));
    }

    remove() {
      Minpubsub.unsubscribe("comment:new", this.remove);
      return super.remove();
    }

    _displayErrorMessage(message) {
      return this.errorEl.html($("<p class=\"information error\">").html(message));
    }

    _disableSubmitButton() {
      return this.submitButtonEl.attr("disabled", "disabled");
    }

    _enableSubmitButton() {
      return this.submitButtonEl.removeAttr("disabled");
    }

    _handleClickToggleCommentOptions(event) {
      event.preventDefault();
      this.commentFormattingHelpView.hide();
      return this.userNoticationSettingsView.toggle();
    }

    _handleClickToggleCommentHelp(event) {
      event.preventDefault();
      this.userNoticationSettingsView.hide();
      return this.commentFormattingHelpView.toggle();
    }

    _handleKeyUp(event) {
      if ($(event.currentTarget).val().length > 10) {
        this.errorEl.empty();
        return this._enableSubmitButton();
      }
    }

    _handleSubmit(event) {
      event.preventDefault();
      this.submitButtonEl.html(i18n.t("comment.messages.posting"));
      this._disableSubmitButton();

      return this.model.save({ body: this.commentBodyEl.val() }, {
        wait: true,
        success: this._handleSubmissionSuccess,
        error: this._handleSubmissionError,
        complete: this._handleSubmissionComplete,
      },
      );
    }

    _handleSubmissionSuccess() {
      track("Comment Created", window.location.pathname, "");
      Minpubsub.publish("comment:created", [this.model]);
      return this.remove();
    }

    _handleSubmissionError(model, error) {
      if (error.status === 422) {
        this._displayErrorMessage(error.responseJSON.detailed_error_message);
        return Flash.now("alert", error.responseJSON.message);
      }
      this._displayErrorMessage(i18n.t("comment.messages.error"));
      return this._enableSubmitButton();
    }

    _handleSubmissionComplete() {
      return this.submitButtonEl.html(i18n.t("comment.button.post_comment"));
    }

    _onTabClick(event) {
      event.preventDefault();

      if (!$(event.target).is(".active")) {
        const target = event.target.href.split("#").pop();
        const tab = $(event.target);

        if (target === "write") {
          this.$el.find(".tab").removeClass("active");
          tab.addClass("active");
          tab.parent().removeClass("preview");
          this.$(".comment-form-reply-preview").hide();
          this.$(".comment-form-reply-write").show();
          return this.$(".comment-form-reply-write textarea").focus();
        }
        if (this.$("textarea").val().length === 0) {
          alert("Please type in a comment.");
          return this.$(".comment-form-reply-write textarea").focus();
        }
        this._loadPreview();

        this.$el.find(".tab").removeClass("active textarea-focus textarea-blur");
        tab.addClass("active");
        tab.parent().addClass("preview");
        this.$(".comment-form-reply-write").hide();
        return this.$(".comment-form-reply-preview").show();
      }
    }

    _loadPreview() {
      const div = this.$(".comment-form-reply-preview");

      // If input hasn't changed from last time, it will re-use existing preview data
      if (!this.currentBodyText || (this.currentBodyText !== this.$("textarea").val())) {
        this.currentBodyText = this.$("textarea").val();

        div.html(`<p class='loading'>${i18n.t("comment.messages.preview_loading")}</p>`);

        return $.ajax({
          url: "/comments/preview",
          type: "POST",
          dataType: "json",
          data: {
            comment: {
              content_id: this.model.get("content_id"),
              body: this.currentBodyText,
            },
          },
          success: data => setTimeout(() => {
            div.html("");
            const commentPreviewView = new CommentPreviewView({ comment: data });
            return commentPreviewView.$el.appendTo(div);
          }
            , 500),
          error: () => div.html(`<p class='loading'>${i18n.t("comment.messages.preview_error")}</p>`),
        });
      }
    }

    _onTextareaFocus() {
      return this.$el.find(".tab[href=\"#write\"]").removeClass("textarea-blur").addClass("textarea-focus");
    }

    _onTextareaBlur() {
      return this.$el.find(".tab[href=\"#write\"]").removeClass("textarea-focus").addClass("textarea-blur");
    }
  };
  CommentFormView.initClass();
  return CommentFormView;
}());
